<template>
    <WarehouseDetails/>
</template>
<script>
import WarehouseDetails from '../../components/warehouses/WarehouseDetails';

export default {
  components: {
    WarehouseDetails,
  },
};
</script>
